import {css} from '@emotion/css';

import {colours} from '../../../../styles/js/variables';

const styles = {
  container: css`
    label: header;
    position: relative;
    z-index: 10;
    width: 100%;
    background-color: ${colours.general.WHITE};
  `,
};

export default styles;
